import React from 'react'
import './ReviewForm.scss'

const Layout = props => (
  <div>

    {props.children}
  </div>
)

export default Layout



// WEBPACK FOOTER //
// ./src/shared/Layout.js